import { __require as n } from "./main66.js";
var e, t;
function d() {
  if (t) return e;
  t = 1;
  var _ = n(), i = "__lodash_hash_undefined__";
  function h(r, a) {
    var s = this.__data__;
    return this.size += this.has(r) ? 0 : 1, s[r] = _ && a === void 0 ? i : a, this;
  }
  return e = h, e;
}
export {
  d as __require
};
